import { loadBetaFeatures } from '~/composables/useBetaFeatures'

export default defineNuxtPlugin(() => {
  loadBetaFeatures()
})
